import { memo } from 'react';
import { Typography, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';

const useStyles = makeStyles()((theme) => ({
  number: {
    marginRight: theme.spacing(1),
  },
}));

interface ExplainerItemProps {
  readonly number: number;
  readonly heading: string;
  readonly subheading: React.ReactNode;
}

export const ExplainerItem = memo<ExplainerItemProps>(({ number, heading, subheading }) => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <Grid
      container
      spacing={isMobile ? 1 : 3}
      alignItems="baseline"
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <Typography
          variant="subtitle2"
          color="disabled"
          display="inline"
          className={classes.number}
        >
          {number}
        </Typography>

        <Typography
          variant="subtitle2"
          display="inline"
          noWrap
        >
          {heading}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={8}
      >
        <Typography
          variant="body1"
          color="textSecondary"
        >
          {subheading}
        </Typography>
      </Grid>
    </Grid>
  );
});
